function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** @jsx h */

/* eslint-disable react/no-deprecated */
import { h, Component } from 'preact';
import { createImageUrl, createResponsiveSrcSet } from '../../helpers';

class SerumLazyResponsivePicture extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "visibleImage", void 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load && !this.props.load) {
      this.loadImage();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  loadImage() {
    const loaderImage = new Image();

    if (this.visibleImage.dataset) {
      loaderImage.srcset = this.visibleImage.dataset.srcset || '';
      loaderImage.sizes = this.visibleImage.sizes || '';
    }

    loaderImage.src = this.visibleImage.dataset.src;

    if (typeof loaderImage.decode === 'function') {
      // Use Image Decode API to decode image upfront if available
      // (Unsure if this works when transferring src to other image, but worth the try)
      loaderImage.decode().then(() => this.updateImage(loaderImage));
    } else if (loaderImage.complete) {
      this.updateImage(loaderImage);
    } else {
      loaderImage.onload = () => this.updateImage(loaderImage);
    }
  }

  updateImage(loaderImage) {
    requestAnimationFrame(() => {
      this.visibleImage.src = loaderImage.currentSrc || loaderImage.src;
    });
  }

  render() {
    const _this$props = this.props,
          className = _this$props.className,
          alt = _this$props.alt,
          id = _this$props.id,
          _this$props$quality = _this$props.quality,
          quality = _this$props$quality === void 0 ? 0.6 : _this$props$quality,
          _this$props$ratio = _this$props.ratio,
          ratio = _this$props$ratio === void 0 ? '16:9' : _this$props$ratio,
          sizes = _this$props.sizes,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style;
    const placeholderSrc = createImageUrl({
      id,
      width: 100,
      quality: 0.6,
      ratio
    });
    const defaultUrl = createImageUrl({
      id,
      width: 1600,
      quality,
      ratio
    });
    const sourceSet = createResponsiveSrcSet({
      id,
      quality,
      ratio
    });
    return h("picture", {
      className: className,
      style: _objectSpread({}, style, {
        display: 'block',
        overflow: 'hidden'
      })
    }, h("img", {
      src: placeholderSrc,
      alt: alt,
      "data-src": defaultUrl,
      "data-srcset": sourceSet,
      style: {
        width: '100%'
      },
      sizes: sizes,
      ref: elm => this.visibleImage = elm
    }));
  }

}

export default SerumLazyResponsivePicture;